import {
    trackEvent,
    eventNameConstants,
    interactionTypeConstants,
    stepInteractionConstants,
} from 'dibs-tracking';

const { EVENT_PRODUCT_INTERACTION } = eventNameConstants;
const { INTERACTION_TYPE_PDP } = interactionTypeConstants;
const { STEP_INTERACTION_PRIMARY_IMAGE_PILL_CLICK, STEP_INTERACTION_FULL_GALLERY_CLICK } =
    stepInteractionConstants;

export const trackPrimaryImagePillClick = (): void => {
    trackEvent({
        eventName: EVENT_PRODUCT_INTERACTION,
        interaction_type: INTERACTION_TYPE_PDP,
        step_interaction_name: STEP_INTERACTION_PRIMARY_IMAGE_PILL_CLICK,
    });
};

export const trackFullGalleryClick = (): void => {
    trackEvent({
        eventName: EVENT_PRODUCT_INTERACTION,
        interaction_type: INTERACTION_TYPE_PDP,
        step_interaction_name: STEP_INTERACTION_FULL_GALLERY_CLICK,
    });
};
